<template>
    <div>
        <div class="form-row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Tipo
                </button>
            </div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum tipo de escala identificado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <template v-if="dado.js_classes">
                            <span class="badge badge-success mr-1" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                {{ classe }}
                            </span>
                        </template>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <i class="fas fa-external-link-alt" v-if="dado.fl_externo"></i>

                            <span class="badge ml-3" :class="'badge-' + dado.st_color">
                                <i class="fas fa-palette"></i>
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_plantao_tipo ? '' : 'Novo' }}
                            Tipo de Escala
                            <span class="badge badge-secondary" v-if="item && item.id_plantao_tipo">
                                #{{ item.id_plantao_tipo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_plantao_tipo" />
                            </div>
                        
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Abreviação"
                                    :validate="validate"
                                    required
                                    v-model="item.st_sigla" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'success', search: 'Verde' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'info', search: 'Ciano' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_color" />
                            </div>

                            <div class="col col-12 col-md-4" v-if="false">
                                <az-input
                                    type="money"
                                    label="Valor Padrão"
                                    v-model="item.dc_valor_plantao" />
                            </div>
                        </div>

                        <div class="d-flex flex-column mt-1" v-if="item.st_color">
                            <span class="badge" :class="'badge-' + item.st_color">
                                &nbsp;
                            </span>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Externo"
                                    :validate="validate"
                                    v-model="item.fl_externo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="3"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-sub-title class="mt-1" title="Classificação Requerida" />
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="plantaoTipo" :id="item.id_plantao_tipo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_plantao_tipo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            options_classes: [],
        }
    },

    props: ['local'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,
        Multiselect
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },
        
        incluir () { 
            this.validate = false;
            
            let item = {
                id_plantao_tipo: null, 
                st_plantao_tipo: "", 
                st_sigla: "", 
                dc_valor_plantao: null, 
                fl_ativo: true,
                fl_externo: false,
                js_classes: [],
                st_color: "secondary",
                st_obs: "", 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'plantao_tipos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
        
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'plantao_tipos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'plantao_tipos',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Escalas", path: "/escalas/escalas"},
                { name: "Tipos", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>